import {CustomPreviewProps} from '@domain/kiln-monitoring'

export const StationSvg = ({x, y, width, height}: CustomPreviewProps) => (
  <>
    <g filter="url(#filter0_d_425_46549)">
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        rx="2"
        fill="url(#paint0_linear_425_46549)"
        fillOpacity="0.5"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_425_46549"
        x={x}
        y={y}
        width={200}
        height={height}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_425_46549" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_425_46549"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_425_46549"
        x1={x}
        y1={y}
        x2={x + width}
        y2={y + height}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8D8C8C" />
        <stop offset="0.169027" stopColor="#CACACA" />
        <stop offset="0.497159" stopColor="white" />
        <stop offset="0.851333" stopColor="#CACACA" />
        <stop offset="1" stopColor="#8D8C8C" />
      </linearGradient>
    </defs>
  </>
)
